import React from "react";
import { Group } from "../core/pdf/types";

export interface GroupState {
	item: Group,
}

export const GroupContext = React.createContext<GroupState | undefined>(undefined);

export function useGroup() {
	return React.useContext(GroupContext);
}
